module.exports = __webpack_public_path__ + "img/not-equal.c99efab3.svg";